import React, { useEffect } from "react";
import { Check, X } from "lucide-react";
import rightmark from "../../../../assets/right-mark-with-background.png";

const plans = [
  { name: "base", price: "$30", color: "bg-[#A335B7]" },
  { name: "premium", price: "$150", color: "bg-[#6E9236]" },
  { name: "premium plus", price: "$230", color: "bg-[#D8922A]" },
  { name: "ultimate", price: "$400", color: "bg-[#3CAABC]" },
];

const rightMarkeImg = (
  <img
    src={rightmark}
    className="mx-autow-5 h-5 sm:w-5 sm:h-5"
    alt="right mark"
  />
);

const paymentSolutions = [
  { name: "smart handhelds", values: [rightMarkeImg, rightMarkeImg, rightMarkeImg, rightMarkeImg] },
  { name: "digital bill", values: ["✗", rightMarkeImg, rightMarkeImg, rightMarkeImg] },
  { name: "digital ordering", values: ["✗", rightMarkeImg, rightMarkeImg, rightMarkeImg] },
  { name: "hybrid ordering", values: ["✗", "✗", "Optional ($199/mo)", rightMarkeImg] },
  { name: "click and collect", values: ["Optional", rightMarkeImg, "Optional ($199/mo)", rightMarkeImg] },
  { name: "payment links", values: ["Optional", rightMarkeImg, rightMarkeImg, rightMarkeImg] },
];

const features = [
  { name: "sunday ai tips", values: [rightMarkeImg, rightMarkeImg, rightMarkeImg, rightMarkeImg] },
  { name: "sunday online reputation", values: ["Optional", rightMarkeImg, rightMarkeImg, rightMarkeImg] },
  { name: "sunday data", values: ["✗", rightMarkeImg, rightMarkeImg, rightMarkeImg] },
  { name: "sunday ai menu", values: ["Optional", rightMarkeImg, rightMarkeImg, rightMarkeImg] },
  { name: "sunday loyalty", values: ["Optional", rightMarkeImg, rightMarkeImg, rightMarkeImg] },
  { name: "sunday performance", values: [rightMarkeImg, rightMarkeImg, "Optional", rightMarkeImg] },
  { name: "sunday enterprise pack", values: ["✗", "✗", "✗", rightMarkeImg] },
  { name: "sunday operations", values: ["✗", rightMarkeImg, rightMarkeImg, rightMarkeImg] },
  { name: "sunday guest app", values: ["✗", "✗", "Optional", "On quote"] },
];

const digitalBill = [
  { name: "visa mastercard discover", values: ["✗", "✗", "save up to 0.25%", "save up to 0.25%"] },
  { name: "amex, tmi cards, corporate cards", values: ["✗", "✗", "save up to 0.25%", "save up to 0.25%"] },
];

const smartHandHelds = [
  { name: "usage fee - for each transaction", values: ["0.15%", "0.15%", "0.15%", "0.15%"] },
  { name: "rental fee per handheld (36mo)", values: ["$40", "$40", "$40", "$40"] },
];

const supportSetup = [
  { name: "support 24/7", values: [rightMarkeImg, rightMarkeImg, rightMarkeImg, rightMarkeImg] },
  { name: "remote onboarding", values: [rightMarkeImg, rightMarkeImg, rightMarkeImg, rightMarkeImg] },
  { name: "physical onboarding", values: ["✗", "✗", "Optional $299", rightMarkeImg] },
  { name: "team members", values: ["–", "$5 / QR code", "$5 / QR code", "$5 / QR code"] },
];

// from now the content is latest one and above one is older one
const freeBusinessFeatures = [
  { name: "business chat - open customer engagement", values: [rightMarkeImg, rightMarkeImg, rightMarkeImg, rightMarkeImg] },
  { name: "in-chat ordering (continuous ordering - pay anytime)", values: [rightMarkeImg, rightMarkeImg, rightMarkeImg, rightMarkeImg] },
  { name: "in-chat cancellations and refunds", values: [rightMarkeImg, rightMarkeImg, rightMarkeImg, rightMarkeImg] },
  { name: "order capacity and q management", values: [rightMarkeImg, rightMarkeImg, rightMarkeImg, rightMarkeImg] },
  { name: "customisable ordering flows", values: [rightMarkeImg, rightMarkeImg, rightMarkeImg, rightMarkeImg] },
  { name: "hybrid ordering - team members and customers", values: [rightMarkeImg, rightMarkeImg, rightMarkeImg, rightMarkeImg] },
  { name: "click and collect", values: [rightMarkeImg, rightMarkeImg, rightMarkeImg, rightMarkeImg] },
  { name: "customer chat prioritisation", values: [rightMarkeImg, rightMarkeImg, rightMarkeImg, rightMarkeImg] },
  { name: "physical/static & mobile locations", values: [rightMarkeImg, rightMarkeImg, rightMarkeImg, rightMarkeImg] },
  { name: "", values: [] },
  { name: "multi location management", values: [rightMarkeImg, rightMarkeImg, rightMarkeImg, rightMarkeImg] },
  { name: "1 location", values: [rightMarkeImg, "✗", "✗", "✗"] },
  { name: "upto 3 location", values: ["✗", rightMarkeImg, "✗", "✗"] },
  { name: "upto 6 locations", values: ["✗", "✗", rightMarkeImg, "✗"] },
  { name: "upto 10 locations", values: ["✗", "✗", "✗", rightMarkeImg] },
  { name: "ratings and reviews", values: [rightMarkeImg, rightMarkeImg, rightMarkeImg, rightMarkeImg] },
];

const freeAIFeature = [
  { name: "in-chat ai customer support", values: ["1k msgs", "40k msgs", "100k msgs", "200k msgs"] },
  { name: "ai order recomendations", values: [rightMarkeImg, rightMarkeImg, rightMarkeImg, rightMarkeImg] },
  { name: "ai order management/placing including customisation", values: [rightMarkeImg, rightMarkeImg, rightMarkeImg, rightMarkeImg] },
  { name: "ai booking & reservations", values: ["coming soon", "coming soon", "coming soon", "coming soon"] },
];

const freePaymentSolutions = [
  { name: "business wallet per location", values: [rightMarkeImg, rightMarkeImg, rightMarkeImg, rightMarkeImg] },
  { name: "manuel or in app payments", values: [rightMarkeImg, rightMarkeImg, rightMarkeImg, rightMarkeImg] },
  { name: "digital invoices and receipts", values: [rightMarkeImg, rightMarkeImg, rightMarkeImg, rightMarkeImg] },
  { name: "upfront payments requests", values: [rightMarkeImg, rightMarkeImg, rightMarkeImg, rightMarkeImg] },
  { name: "payment now requests", values: [rightMarkeImg, rightMarkeImg, rightMarkeImg, rightMarkeImg] },
  { name: "group ordering and payments", values: [rightMarkeImg, rightMarkeImg, rightMarkeImg, rightMarkeImg] },
  { name: "bill and invoice splitting", values: [rightMarkeImg, rightMarkeImg, rightMarkeImg, rightMarkeImg] },
  { name: "customer payment history", values: [rightMarkeImg, rightMarkeImg, rightMarkeImg, rightMarkeImg] },
  { name: "in-app tipping", values: [rightMarkeImg, rightMarkeImg, rightMarkeImg, rightMarkeImg] },
];

const geoMarketingSolutions = [
  { name: "digital storefront per location", values: ["1", "3", "6", "10"] },
  { name: "full market place access", values: [rightMarkeImg, rightMarkeImg, rightMarkeImg, rightMarkeImg] },
  { name: "digital menus & digital catalogues", values: ["2", "10", "20", "40"] },
  { name: "team association and visibility", values: ["5", "60", "150", "200"] },
  { name: "social media, posting (per month)", values: ["10", "100", "300", "500"] },
  { name: "likes, following and sharing", values: [rightMarkeImg, rightMarkeImg, rightMarkeImg, rightMarkeImg] },
  { name: "group chats", values: [rightMarkeImg, rightMarkeImg, rightMarkeImg, rightMarkeImg] },
  { name: "events (per month)", values: ["5", "25", "60", "150"] },
  { name: "fast marketing via posts and text (additional fee)", values: [rightMarkeImg, rightMarkeImg, rightMarkeImg, rightMarkeImg] },
  { name: "marketing and engagement insights", values: [rightMarkeImg, rightMarkeImg, rightMarkeImg, rightMarkeImg] },
];

const freeInventSolutions = [
  { name: "menu's and catalogues per location, timed", values: [rightMarkeImg, rightMarkeImg, rightMarkeImg, rightMarkeImg] },
  { name: "item inventory per location", values: [rightMarkeImg, rightMarkeImg, rightMarkeImg, rightMarkeImg] },
  { name: "item scanner", values: [rightMarkeImg, rightMarkeImg, rightMarkeImg, rightMarkeImg] },
  { name: "inventory dashboard", values: [rightMarkeImg, rightMarkeImg, rightMarkeImg, rightMarkeImg] },
];

const ResponsiveSection = ({ title, data }) => {
  const renderRow = (feature, idx) => {
    return (
      <div
        key={idx}
        className={`grid grid-cols-[2fr,1fr,1fr,1fr,1fr] sm:w-[500px]  md:w-[1340px] lg-xl:w-[1325px] xl-2xl:w-[1410px] px-2 sm:px-4 ml-2 sm:ml-6 md:ml-10 md-xl:ml-[20px] lg-xl:ml-[30px] xl-2xl:ml-[15px] text-center items-center ${
          ((idx % 2 === 0 || idx === 17) && (idx != 13 && idx != 14 && idx != 15 && idx != 16)) ? "bg-gray-100" : (idx === 10 ? "bg-white mb-[-2rem]" : "bg-white")
        } `}
      >
        <div
          className={`flex items-center text-left font-normal 
    text-[13px] sm:text-[15px] md:text-[18px] 
    px-3 py-3 text-[#666666]
    ${idx >= 13 && idx <= 16
              ? "pl-14 sm:pl-20 md:pl-32 lg:pl-40"
              : ""
            }`}
        >
          {feature.name}
        </div>
        {feature.values.map((val, i) => (
          <div
            key={i}
            className="flex justify-center items-around text-[13px] sm:text-[15px] md:text-[18px] px-2 sm:px-3 py-3 text-[#666666]"
          >
            {val === "✓" ? (
              <Check className="text-purple-600 w-4 h-4 sm:w-5 sm:h-5" />
            ) : val === "✗" ? (
              <X className="text-black w-4 h-4 sm:w-5 sm:h-5" />
            ) : (
              <span className="text-gray-600">{val}</span>
            )}
          </div>
        ))}
      </div>
    );
  };

  return (
    <>
      <div className="pt-6 text-[24px] sm:text-xl md:text-2xl text-gray-800 w-[800px] sm:w-[550px] ml-2 sm:ml-6 md:ml-10 lg:ml-9 xl-2xl:ml-[15px] pb-[20px] font-semibold ">
        {title}
      </div>
      {data.map((feature, idx) => renderRow(feature, idx))}
    </>
  );
};

const PricingNavContentPageCompare = ({ onBack }) => {
  useEffect(() => {
    // window.scrollTo({ top: 0, behavior: "smooth" });
  }, []);

  return (
    // ✅ ONE common horizontal scroll container
    <div className="w-full overflow-x-auto bg-white px-2 sm:px-6 md:px-10 py-10 ">
      <div className="min-w-[1380px] sm:min-w-[500px] mx-auto">
        <h2 className="lg-xl:px-[20px] xl-2xl:px-[10px] py-10 text-2xl sm:text-3xl md:text-[50px] font-semibold text-left md:text-left">
          compare all in the details
        </h2>

        {/* Header — fixed grid structure for perfect alignment */}
        <div className="grid grid-cols-[2fr,1fr,1fr,1fr,1fr] sm:w-[50px] w-[200px] text-center font-semibold border-gray-300 ml-2 sm:ml-[175px] md:ml-[530px] lg-xl:ml-[500px]">

          {plans.map((plan, idx) => (
            <div key={idx} className=" p-[7px] sm:-mx-6">
              <div
                className={`text-white rounded-lg inline-block ${plan.color} 
                w-[120px] sm:w-[60px] md:w-[198px]  lg-xl:w-[205px] xl-2xl:w-[210px] 
                h-8 sm:h-7 md:h-10
                flex items-center justify-center 
                text-sm sm:text-[9px] md:text-2xl ml-12 md:ml-0`}
              >
                {plan.name}
              </div>

              <div className="pt-3 sm:pt-2 sm:ml-[40px]">
                <span className="text-lg sm:text-[10px] md:text-4xl xl-2xl:text-[35px] font-bold ">
                  {plan.price}
                </span>
                <span className="ml-1 sm:ml-1 xl-2xl:ml-[20px] text-xs sm:text-[10px] md:text-base">
                  /month
                </span>
              </div>
            </div>
          ))}
        </div>

        {/* Common sections */}
        {/* <ResponsiveSection title="payment solutions" data={paymentSolutions} />
        <ResponsiveSection title="features" data={features} />
        <ResponsiveSection title="digital bill via qr code" data={digitalBill} />
        <ResponsiveSection title="smart handhelds" data={smartHandHelds} />
        <ResponsiveSection title="support and setup" data={supportSetup} /> */}
        <ResponsiveSection title="free business features" data={freeBusinessFeatures} />
        <ResponsiveSection title="free ai features" data={freeAIFeature} />
        <ResponsiveSection title="free payment solutions" data={freePaymentSolutions} />
        <ResponsiveSection title="geo marketing solutions" data={geoMarketingSolutions} />
        <ResponsiveSection title="free inventory solutions" data={freeInventSolutions} />
      </div>
    </div>
  );
};

const CheckmarkIconWithBgWhite = ({ size = 24 }) => (
  <svg viewBox="0 0 512 512">
    <circle cx="256" cy="256" r="256" fill="#6E3FC6" />
    <polyline
      points="160,256 230,320 352,192"
      fill="none"
      stroke="#FFFFFF"
      strokeWidth="32"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default PricingNavContentPageCompare;
